var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}



document.addEventListener("DOMContentLoaded", function () {
  function updateHeaderOffset() {
    var announcementBar = document.querySelector("#shopify-section-sections--24452266393923__announcement-bar");
    var headerContainer = document.querySelector("#shopify-section-sections--24452266393923__header");

    if (!headerContainer) return;

    if (window.innerWidth >= 990) {
      // Only apply sticky behavior on desktop
      if (announcementBar) {
        var announcementHeight = announcementBar.offsetHeight;
        // If the header container is static, change it to sticky so that top works.
        if (getComputedStyle(headerContainer).position === "static") {
          headerContainer.style.position = "sticky";
        }
        headerContainer.style.top = announcementHeight + "px";
      }
    } else {
      // Reset the styles on mobile
      headerContainer.style.position = "";
      headerContainer.style.top = "";
    }
  }

  updateHeaderOffset();
  window.addEventListener("resize", updateHeaderOffset);
});

